import * as React from "react";

import { getFormattedDate } from "@stadium/helpers/dayjs";
import { HERO_DEFAULTS, H_08 } from "@stadium/shared/src/helpers/plasmic/static-slices";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import styles from "./main.module.scss";

interface ImageWithAlt {
  image: string;
  alt: string;
}

export interface H08Props {
  heading?: string;
  description?: string;
  teamTitle?: string;
  teamDate?: string;
  teamDateFormat?: string;
  summaryDescription?: string;
  badgeLogo?: ImageWithAlt;
  image?: ImageWithAlt;
  className?: string;
  testimonialHeading?: string;
  testimonial?: {
    testimonialAuthorName: string;
    testimonialAuthorImage: ImageWithAlt;
    testimonialAuthorCompanyLogo?: ImageWithAlt;
  };
}

const defaults = HERO_DEFAULTS[H_08];

const H08: React.FC<Readonly<H08Props>> = ({
  heading = defaults.heading,
  description = defaults.description,
  summaryDescription = defaults.summaryDescription,
  teamTitle = defaults.teamTitle,
  teamDate,
  teamDateFormat = "Do MMM YYYY",
  testimonialHeading = defaults.testimonialHeading,
  badgeLogo = defaults.badgeLogo,
  image = defaults.image,
  className = defaults.className,
  testimonial = {
    testimonialAuthorName: defaults.testimonial.testimonialAuthorName,
    testimonialAuthorImage: defaults.testimonial.testimonialAuthorImage,
    testimonialAuthorCompanyLogo: defaults.testimonial.testimonialAuthorCompanyLogo,
  },
}) => {
  const formattedDate = getFormattedDate(teamDate || new Date().toISOString(), teamDateFormat);
  return (
    <section className={`${styles.sectionWrapper} ${className || ""}`}>
      <div className={styles.divWrapper}>
        <div className={styles.h08ContentWrapper}>
          <div className={styles.leftContent}>
            <h1 className={styles.heading}>{heading}</h1>
            <p className={styles.description}>{description}</p>
          </div>

          {badgeLogo?.image && (
            <div className={styles.rightContent}>
              <div className={styles.badgeLogo}>
                <Multimedia
                  type="image"
                  src={badgeLogo.image}
                  alt={badgeLogo.alt}
                  className={styles.badgeLogoImage}
                />
              </div>
              <div>
                <h1 className={styles.teamTitle}>{teamTitle}</h1>
                <p className={styles.teamDate}>{formattedDate}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.testimonialWrapper}>
        <div className={styles.imageWrapper}>
          <Multimedia type="image" src={image?.image} alt={image?.alt} className={styles.image} />
        </div>
        <div className={styles.summaryContainerWarpper}>
          <div className={styles.summaryContainer}>
            {(testimonial.testimonialAuthorImage?.image ||
              testimonial.testimonialAuthorCompanyLogo?.image) && (
              <div className={styles.authorContainer}>
                <div className={styles.authorWrapper}>
                  {testimonial.testimonialAuthorImage?.image && (
                    <div className={styles.authorImageWrapper}>
                      <Multimedia
                        type="image"
                        src={testimonial.testimonialAuthorImage.image}
                        alt={testimonial.testimonialAuthorImage.alt}
                        className={styles.image1}
                      />
                    </div>
                  )}
                  {testimonial.testimonialAuthorCompanyLogo?.image && (
                    <div className={styles.authorCompanyLogoWrapper}>
                      <Multimedia
                        type="image"
                        src={testimonial.testimonialAuthorCompanyLogo.image}
                        alt={testimonial.testimonialAuthorCompanyLogo.alt}
                        className={styles.image1}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className={styles.contentContainer}>
              {testimonialHeading && (
                <h2 className={styles.testimonialHeading}>{testimonialHeading}</h2>
              )}
              <p className={styles.summaryDescription}>{summaryDescription}</p>
              {testimonial.testimonialAuthorName && (
                <h1 className={styles.authorName}>{testimonial.testimonialAuthorName}</h1>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default H08;
